import { render, staticRenderFns } from "./wishList.vue?vue&type=template&id=aaefb7e0&scoped=true"
import script from "./wishList.vue?vue&type=script&lang=js"
export * from "./wishList.vue?vue&type=script&lang=js"
import style0 from "./wishList.vue?vue&type=style&index=0&id=aaefb7e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaefb7e0",
  null
  
)

export default component.exports